// extracted by mini-css-extract-plugin
module.exports = {"button":"SuccessButton_button__3ZNp5","shadow":"SuccessButton_shadow___TcS7"};